import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { RootState } from '../../../../types/common.types';
import { ProgrammeSummary } from '../../../../types/entity.types';

import { ACTIVE, ARCHIVED, UPCOMING } from '../../../../utils/constants';

import ProgrammeMenuSection from './programme-menu-section/ProgrammeMenuSection';

import './programme-menu.scss';

type Props = {
  onNavigate?: (value: string) => void;
};

const ProgrammeMenu = ({ onNavigate }: Props) => {
  const navigate = useNavigate();

  const programmes = useSelector(({ programme }: RootState) => programme.programmeSummaries);

  const [activeProgrammes, setActiveProgrammes] = useState<ProgrammeSummary[]>([]);
  const [upcomingProgrammes, setUpcomingProgrammes] = useState<ProgrammeSummary[]>([]);
  const [archivedProgrammes, setArchivedProgrammes] = useState<ProgrammeSummary[]>([]);

  useEffect(() => {
    if (programmes) {
      setActiveProgrammes([...programmes.filter((programme) => programme.status === ACTIVE)]);
      setUpcomingProgrammes([...programmes.filter((programme) => programme.status === UPCOMING)]);
      setArchivedProgrammes([...programmes.filter((programme) => programme.status === ARCHIVED)]);
    }
  }, [programmes]);

  return (
    <div className="programme-menu" data-testid="programme-menu">
      <div className="programme-menu__items">
        <ProgrammeMenuSection heading="Active Programmes" programmes={activeProgrammes} onNavigate={onNavigate} />
        <ProgrammeMenuSection heading="Upcoming Programmes" programmes={upcomingProgrammes} onNavigate={onNavigate} />
        <ProgrammeMenuSection heading="Archived Programmes" programmes={archivedProgrammes} onNavigate={onNavigate} />
      </div>
      <div className="programme-menu__button" onClick={() => navigate('/programmes/new/general')}>
        <FontAwesomeIcon icon={faPlus} />
        <span>Create New Programme</span>
      </div>
    </div>
  );
};

export default ProgrammeMenu;
